import { User, SurveyVersion, SurveyAnswer, DemographicResponses } from '../models';
import { HasId } from '../interfaces';

export class SurveyInstance implements HasId {
    public id: number;
    public uniqueIdentifier: string;
    public userID: number;
    public user: User;
    public surveyVersionID: number;
    public surveyVersion: SurveyVersion;
    public responses: SurveyAnswer[];
    public demographics?: DemographicResponses;
    public active: boolean;
    public priceId: string;
    public modifiedByUserID?: number;

    public completedDate: Date;
    public expirationDate: Date;

    constructor(user?: User, surveyVersion?: SurveyVersion) {
        if (!!user) {
            this.user = user;
        }
        if (!!surveyVersion) {
            this.surveyVersion = surveyVersion;
        }
    }
}


// WEBPACK FOOTER //
// ./src/models/SurveyInstance.tsx